import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
  Spinner,
} from 'reactstrap';
import usePatch from '../../helpers/hooks/usePatch';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import _ from 'lodash';
const FarmerDetail = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [farmer, , farmerLoading, loadFarmers] = useGet(
    `/farmers/${id}?filter[include][0][relation]=language&filter[include][1][relation]=district&filter[include][2][relation]=fieldArea&filter[include][3][relation]=city`,
    true
  );
 
  const [districts, , districtsLoading] = useGet('/districts', true);
  const [cities, , citiesLoading] = useGet('/cities', true);
  const [languages, , languagesLoading] = useGet('/languages', true);
  const [vegetables, , vegetablesLoading] = useGet('/vegetables', true);
  const [fieldAreas, , fieldAreasLoading] = useGet('/field-areas', true);

  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedFieldArea, setSelectedFieldArea] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedRabiCrops, setSelectedRabiCrops] = useState([]);
  const [selectedKhareefCrops, setSelectedKhareefCrops] = useState([]);
  const [selectedOwnership, setSelectedOwnership] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [postFarmer, postedData, postingError, dataPosting] = usePatch(
    `/farmers/${id}`
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();

  // const handleToggler = (farmer, packages) => {
  //   postFarmer({ packages }, `/farmers/${farmer.id}`).then((e) =>
  //     loadFarmers()
  //   );
  // };

  const handleFormSubmit = (event, errors, values) => {
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }
    if (
      !selectedDistrict ||
      !selectedLanguage ||
      !selectedFieldArea ||
      !selectedGender ||
      !selectedCity ||
      !selectedRabiCrops ||
      !selectedKhareefCrops ||
      !selectedOwnership
    ) {
      return toastr.warning('Please fix errors in the form');
    }
    if (selectedRabiCrops.length === 0 || selectedKhareefCrops.length === 0) {
      return toastr.warning('Please fix errors in the form');
    }
    const obj = _.omit(
      {
        ...values,
        gender: selectedGender.value,
        districtId: selectedDistrict.value,
        languageId: selectedLanguage.value,
        fieldAreaId: selectedFieldArea.value,
        cityId: selectedCity.value,
        rabiVegetableIds: selectedRabiCrops.map((x) => x.value),
        khareefVegetableIds: selectedKhareefCrops.map((x) => x.value),
        ownership: selectedOwnership.map((x) => x.value),
        age: parseInt(values.age),
      },
      'phone'
    );

    if (selectedImage) {
      upload([selectedImage]).then((_urls) => {
        postFarmer({ ...obj, profilePicture: _urls[0] });
      });
    } else {
      postFarmer(obj);
    }
  };
  useEffect(() => {
    if (farmer) {
      setSelectedDistrict({
        value: farmer.district?.id,
        label: farmer.district?.name,
      });
      setSelectedCity({
        value: farmer.city?.id,
        label: farmer.city?.name,
      });
      setSelectedLanguage({
        value: farmer.language?.id,
        label: farmer.language?.title,
      });
      setSelectedFieldArea({
        value: farmer.fieldArea?.id,
        label: farmer.fieldArea?.name,
      });
      setSelectedGender({
        value: farmer?.gender,
        label: farmer?.gender,
      });
      setSelectedOwnership(
        farmer?.ownership?.map((x) => ({ value: x, label: x }))
      );
      setSelectedRabiCrops(
        farmer?.rabiVegetables?.map((x) => ({ value: x.id, label: x.name }))
      );
      setSelectedKhareefCrops(
        farmer?.khareefVegetables?.map((x) => ({ value: x.id, label: x.name }))
      );
    }
  }, [farmer]);
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Farmer has been updated successfully');
      history.push('/users/farmers');
    }
  }, [history, postedData]);

  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit Farmer</h4>
                <Card>
                  <CardBody>
                    {farmerLoading ? (
                      <div className='text-center'>
                        <Spinner className='mr-2' color='primary' />
                      </div>
                    ) : (
                      <>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor='name'>Name</Label>
                              <AvField
                                name='name'
                                placeholder='Name'
                                type='text'
                                errorMessage='Enter Name'
                                className='form-control'
                                validate={{ required: { value: true } }}
                                id='name'
                                value={farmer?.name}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <Label>Gender</Label>
                            <Select
                              value={selectedGender}
                              onChange={(e) => setSelectedGender(e)}
                              options={[
                                { value: 'مرد', label: 'مرد' },
                                { value: 'عورت', label: 'عورت' },
                              ]}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={1}>
                            <img
                              src={farmer?.profilePicture}
                              className='rounded-circle avatar-sm card-img'
                            />
                          </Col>
                          <Col md={11}>
                            <FormGroup>
                              <div
                                className='custom-file'
                                style={{ zIndex: 0 }}
                              >
                                <CustomInput
                                  type='file'
                                  className='custom-file-input'
                                  id='image'
                                  accept='image/*'
                                  onChange={(e) => {
                                    setSelectedImage(e.target.files[0]);
                                  }}
                                />
                                <Label
                                  className='custom-file-label'
                                  htmlFor='image'
                                >
                                  {selectedImage
                                    ? selectedImage.name
                                    : 'Change Profile Picture'}
                                </Label>
                              </div>
                              {selectedImage && (
                                <span className='d-block font-size-20 text-danger text-right'>
                                  <i
                                    onClick={() => setSelectedImage(null)}
                                    style={{ cursor: 'pointer' }}
                                    className='ri-close-line'
                                  ></i>
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor='phone'>Phone</Label>
                              <AvField
                                disabled
                                name='phone'
                                placeholder='Phone (923xxxxxxxxxx)'
                                type='text'
                                errorMessage='Enter Phone in (923xxxxxxxxxx)'
                                className='form-control'
                                validate={{
                                  required: { value: true },
                                  pattern: { value: '^923' },
                                  minLength: { value: 12 },
                                  maxLength: { value: 12 },
                                }}
                                id='name'
                                value={farmer?.phone}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor='phone'>Age</Label>
                              <AvField
                                name='age'
                                placeholder='Age'
                                type='number'
                                errorMessage='Enter Age'
                                className='form-control'
                                validate={{
                                  required: { value: true },

                                  min: { value: 1 },
                                  max: { value: 100 },
                                }}
                                id='name'
                                value={farmer?.age}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <FormGroup>
                              <Label>Language</Label>
                              <Select
                                isLoading={languagesLoading}
                                value={selectedLanguage}
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedLanguage(e)}
                                options={languages?.map((x) => ({
                                  value: x.id,
                                  label: x.title,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Rabi Crops</Label>
                              <Select
                                isLoading={vegetablesLoading}
                                value={selectedRabiCrops}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedRabiCrops(e)}
                                options={vegetables?.map((x) => ({
                                  value: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Khareef Crops</Label>
                              <Select
                                isLoading={vegetablesLoading}
                                value={selectedKhareefCrops}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedKhareefCrops(e)}
                                options={vegetables?.map((x) => ({
                                  value: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Ownership</Label>
                              <Select
                                value={selectedOwnership}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedOwnership(e)}
                                options={[
                                  { value: 'مالک', label: 'مالک' },
                                  { value: 'مزارع', label: 'مزارع' },
                                  { value: 'ٹھیکہ', label: 'ٹھیکہ' },
                                ]}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Field Area</Label>
                              <Select
                                loading={fieldAreasLoading}
                                value={selectedFieldArea}
                                onChange={(e) => setSelectedFieldArea(e)}
                                options={fieldAreas?.map((x) => ({
                                  id: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <Label htmlFor='phone'>Address</Label>
                          <AvField
                            name='locationAddress'
                            placeholder='Address'
                            type='text'
                            errorMessage='Enter Address'
                            className='form-control'
                            validate={{
                              required: { value: true },
                            }}
                            id='locationAddress'
                            value={farmer?.locationAddress}
                          />
                        </FormGroup>
                        <Row>
                          <Col>
                            <FormGroup>
                              <Label>City</Label>
                              <Select
                                loading={citiesLoading}
                                value={selectedCity}
                                onChange={(e) => setSelectedCity(e)}
                                options={cities?.map((x) => ({
                                  id: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <Label>District</Label>
                              <Select
                                isLoading={districtsLoading}
                                value={selectedDistrict}
                                closeMenuOnSelect={true}
                                onChange={(e) => setSelectedDistrict(e)}
                                options={districts?.map((x) => ({
                                  value: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className='d-flex'>
                          <Label className='mr-3'>Farmer Active?</Label>
                          <AvField
                            name='isActive'
                            placeholder='Address'
                            type='checkbox'
                            validate={{
                              required: { value: false },
                            }}
                            id='isActive'
                            value={farmer?.isActive}
                          />
                        </div>
                        <div className='d-flex'>
                          <Label className='mr-3'>Farmer Package activation?</Label>
                          <AvField
                            name='packages'
                            placeholder='Address'
                            type='checkbox'
                            validate={{
                              required: { value: false },
                            }}
                            id='packages'
                            value={farmer?.packages}
                          />
                          {/* <Button color='danger' size='sm' onClick={()=>handleToggler(farmer, !farmer.packages)} >
                            {farmer?.packages ? 'Deactivate' : 'Activate'}
                          </Button>  */}
                        </div>
                        {/* <div className='border mb-3 mt-2'></div>
                        <FormGroup>
                          <Label htmlFor='password'>Change Password</Label>
                          <AvField
                            name='password'
                            placeholder='Password'
                            type='text'
                            errorMessage='Minimun length required is 5'
                            className='form-control'
                            validate={{
                              minLength: { value: 5 },
                            }}
                            id='password'
                          />
                        </FormGroup> */}
                      </>
                    )}
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Update Farmer'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default FarmerDetail;
